const riot = require('riot');

riot.tag2('modal-multiple-create-note', '<div class="relative f fclm w70per h90per p20 rounded-12 bg-white overflow-hidden mx16 s-w-full s-p8 m-w-full" ref="modal"><i class="icon-close absolute t16 r16 fs24 text-label_dark_medium cursor-pointer" onclick="{close}"></i> <div class="fs16 lh15 bold mt20 mb32">ノートを複数作成する</div> <div class="mb24"> <div class="f fm mb16"> <div class="fs16 bold mr8">親チケットを紐づける</div><i class="icon-help cursor-pointer fs20 mbn2 tooltip" aria-label="任意: 親チケットを紐づけると、子チケット、親チケット相互に参照が挿入されます。" data-tooltip-position="top"></i> </div> <div class="p20 border rounded-4"> <div class="f fm"> <button class="button primary flex-fixed h32 fs12 p6 mr8" type="button" onclick="{onToggleNotesPopup}">親チケット{parentNote ? ⁗変更⁗ : ⁗選択⁗}</button> <div class="f fm" if="{parentNote}"> <button class="bold text-primary fs16 line-clamp-1 mr4 tooltip" onclick="{openParentNote}" aria-label="開く" data-tooltip-position="top">: {parentNote.data.title || \'タイトルなし\'} </button><i class="icon-close fs24 cursor-pointer flex-fixed mbn2" onclick="{deleteParentNote}"></i> </div> </div> </div> </div> <div class="h80per p20 border rounded-4 overflow-y-scroll mb40 s-p5"> <div class="f w-full text-left my10"> <div class="col2 pr10 s-col3 s-pr5"></div> <div class="col4 pr20 pl5 fs16 s-pr10 s-fs13">タイトル</div> <div class="col5 fs16 pl5 s-col5 s-fs13">タスク内容</div> </div> <div ref="note_input" data-is="item-note-input_" input="{input}" index="{index}" each="{input, index in initialInputs}" onkeydownenter="{addNewInput}"></div> <div class="f fc"> <button class="button primary w220 transition" onclick="{addNewInput}">+ ノートを追加する</button> </div> </div> <div class="f fc mb20"> <button class="button deep w220 transition" onclick="{createMultipleNote}">ノートを作成する</button> </div> </div>', 'modal-multiple-create-note,[data-is="modal-multiple-create-note"]{background-color:rgba(0,0,0,0.5)} modal-multiple-create-note input,[data-is="modal-multiple-create-note"] input,modal-multiple-create-note input.input,[data-is="modal-multiple-create-note"] input.input{border:1px solid transparent;border-radius:8px !important;padding:8px 12px;height:32px}', 'class="f fh" spat-animation="push"', function(opts) {
    this.parentNote = null;

    this.initialInputs = [
      {
        title: "",
        content: "",
      },
    ];

    this.addNewInput = () => {
      this.initialInputs.push({ title: "", content: "" });
      this.update();
    };

    this.handleKeydown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.createMultipleNote();
      }
    };

    this.createMultipleNote = async () => {
      let filtered = [].concat(this.refs.note_input || []).filter(tag => {
        let { title } = tag.getValue();
        return !!title;
      });

      let promises = filtered.map((input) => {
        let { title, content } = input.getValue();
        let formatted_content = `# ${title}\n\n${content}`;

        if (this.parentNote) {
          formatted_content += "\n\n## 親チケット\n" + app.utils.getInsertLinkToTitle({
            title: this.parentNote.data.title,
            url: `/${this.parentNote.path}`,
            bold: true,
          });
        }
        return app.store.project.createNote({
          title: app.utils.getTitle(formatted_content),
          content: formatted_content,
          column_id: this.opts.column_id,
        });
      });

      let indicator = null;

      try {
        indicator = spat.modal.indicator();
        const notes = await Promise.all(promises);

        if (this.parentNote) {
          await this.addReferredNotes(notes);
        }

        spat.toast.message(`${promises.length}件のノートを作成しました`, { icon: "template", timeout: 2048 });
        this.close();

        if (this.parentNote) {
          this.openParentNote();
        }
      } catch {
        spat.modal.alert("ノート作成に失敗しました");
      } finally {
        indicator && indicator.close();
      }
    };

    this.onToggleNotesPopup = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const popup = spat.popup.open('popup-suggestion-notes', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 16,
        align: { x: 'left' },
        position: 'bottom',
        opts: {
          disableSelectMode: true,
        },
      });
      const result = await popup.waitClose();
      if (!result) return;
      this.parentNote = result[0];
      this.update();
    };

    this.openParentNote = async () => {
      if (app.useragent.isMobile) {
        spat.router.push(`/${this.parentNote.path}`);
      }
      else {
        let modal = spat.modal.open('modal-note', {
          note: this.parentNote,
        });

        await modal.waitClose();
        this.update();
      }
    };

    this.deleteParentNote = () => {
      this.parentNote = null;
    };

    this.addReferredNotes = async (notes) => {
      const promises = [
        this.parentNote.getProject().fetch(),
        this.getFormattedListContent(notes),
      ];
      const [project, content] = await Promise.all(promises);

      try {

        let child_note_ids = [
          ...this.parentNote.data.child_note_refs.map(ref => ref.id),
          ...notes.map(n => n.id)
        ];
        await app.api.child(this.parentNote.ref.path).put({
          child_note_ids,
        });

        await app.api.child(this.parentNote.ref.path).child('messages').post({
          content: `関連ノートが作成されました\n\n${content}`,
        });
      }
      catch (e) {
        console.log(e.message);
      }
    };

    this.getFormattedListContent = async (notes) => {
      const formatted_list = await Promise.all(
        notes.map(note => {
          return `- ${app.utils.getInsertLinkToTitle({
            title: note.title,
            url: `/workspaces/${app.store.workspace_id}/projects/${app.store.project_id}/notes/${note.id}`,
            bold: true,
          })}`;
        })
      );
      return formatted_list.join('\n');
    };

});
riot.tag2('item-note-input_', '<div class="w-full f fm pb20 border-bottom border-separator_opacity text-center mb20"> <div class="col2 pr10 fs16 s-col3 s-pr5 s-fs13">ノート: {opts.index + 1}</div> <div class="col4 pr20 s-pr10"> <input class="input light_secondary w-full border border-black" ref="title" type="text" placeholder="入力してください" riot-value="{opts.input.title}" onkeydown="{onKeyDown}"> </div> <div class="col6 pr20 s-col5 s-pr5"> <input class="input light_secondary w-full border border-black" ref="content" type="text" placeholder="入力してください" riot-value="{opts.input.content}" onkeydown="{onKeyDown}"> </div> </div>', '', '', function(opts) {
    this.mixin('enableOptsEventHandler');

    this.getValue = () => {
      return { title: this.refs.title.value, content: this.refs.content.value };
    };

    this.onKeyDown = (e) => {

      if (e.isComposing) return;
      if (e.code === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        this.trigger(`keydownenter`);
      }
    };
});